import { createSelector } from 'reselect'

const PHONE_NUMBERS_LIMIT = 3

const sliceSelector = (state) => state.phoneNumbers

export const createPhoneNumberUuidSelector = (e164PhoneNumber) => (
  createSelector(
    sliceSelector,
    ({ collection }) => {
      const { uuid } = collection.find((phoneNumber) => phoneNumber.e164_phone_number === e164PhoneNumber) || {}
      return uuid
    },
  )
)

export const verificationErrorsSelector = createSelector(
  sliceSelector,
  ({ verification: { errors } }) => errors
)

export const verificationStatusSelector = createSelector(
  sliceSelector,
  ({ verification: { status } }) => status
)

export const phoneNumbersSelector = createSelector(
  sliceSelector,
  ({ collection }) => collection || []
)

export const phoneNumberToRemoveSelector = createSelector(
  sliceSelector,
  ({ phoneNumberUuidToRemove, collection }) => (
    collection.find(({ uuid }) => phoneNumberUuidToRemove === uuid) || {}
  )
)

export const nextPrimaryPhoneNumberSelector = createSelector(
  sliceSelector,
  ({ collection, phoneNumberUuidToRemove }) => (
    collection.filter(({ uuid }) => uuid !== phoneNumberUuidToRemove)[0] || {}
  )
)

export const phoneNumbersLoadingStateSelector = createSelector(
  sliceSelector,
  ({ loadingState }) => loadingState
)

export const phoneNumbersPresentSelector = createSelector(
  phoneNumbersSelector,
  (collection) => !!collection.length
)

export const primaryPhoneNumberSelector = createSelector(
  phoneNumbersSelector,
  (collection) => collection.find(({ primary }) => primary)
)

export const phoneNumbersLimitReachedSelector = createSelector(
  phoneNumbersSelector,
  (collection) => collection.length >= PHONE_NUMBERS_LIMIT
)

export const primaryPhoneNumberStatusSelector = createSelector(
  sliceSelector,
  ({ primaryPhoneNumberStatus }) => primaryPhoneNumberStatus
)

export const phoneNumberRemovalStatusSelector = createSelector(
  sliceSelector,
  ({ phoneNumberRemovalStatus }) => phoneNumberRemovalStatus
)
